import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";
import { Reveal, Eyebrow, EASE } from "./Reveal";

export const Leaks = () => {
  const { t } = useLang();
  const l = t.leaks;
  return (
    <section id="pierderi" className="section" data-testid="leaks-section">
      <div className="container-x grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal><Eyebrow>{l.eyebrow}</Eyebrow></Reveal>
            <Reveal delay={0.05}>
              <h2 className="h2 mt-6">{l.title} <span className="font-serif font-normal italic text-zinc-400">{l.titleAccent}</span></h2>
            </Reveal>
            <Reveal delay={0.1}><p className="mt-6 max-w-md text-zinc-300">{l.intro}</p></Reveal>
          </div>
        </div>
        <div className="lg:col-span-7">
          <ol className="border-t border-line">
            {l.items.map((it, i) => (
              <motion.li key={it} initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.8, delay: i * 0.08, ease: EASE }} className="leak-row group grid grid-cols-[3rem_1fr] gap-4 border-b border-line py-8 sm:grid-cols-[5rem_1fr]" data-testid={`leak-item-${i}`}>
                <span className="font-mono text-sm text-red-400">−0{i + 1}</span>
                <p className="text-lg leading-snug text-ink transition-transform duration-500 group-hover:translate-x-2 sm:text-2xl">{it}</p>
              </motion.li>
            ))}
          </ol>
          <Reveal><p className="mt-10 max-w-xl text-zinc-300">{l.outro}</p></Reveal>
          <Reveal delay={0.1}><p className="mt-6 font-serif text-4xl italic text-gold sm:text-5xl" data-testid="leaks-punch">{l.punch}</p></Reveal>
        </div>
      </div>
    </section>
  );
};
